<template>
  <v-container fluid style="height: 100%;">
    <v-container fluid class="app-container" style="height: 100%;">
      <router-view></router-view>
    </v-container>
  </v-container>
</template>

<script>
export default {
  methods: {
  },
  created() {
  },
};
</script>

<style>
  .app-container {
    border-radius: 2px;
    background-color: white;
    min-height: 500px;
  }
</style>
